import { TriggerBuilder } from "@redriver/cinnamon";
import React from "react";
import { downloadTemplateDocument } from "./actions";
import { saveDownloadResponse } from "modules/documentHelpers";
import { BaseDocumentTile } from "components/containers";

const TemplateDocumentItem = ({
  documentType,
  title,
  downloadName,
  fileExtension,
}) => {
  const fullName = downloadName + "." + fileExtension;
  return (
    <TriggerBuilder
      submitAction={downloadTemplateDocument}
      submitParams={documentType}
      onSubmitted={(response) => saveDownloadResponse(response, fullName)}
      renderTrigger={(fire) => (
        <BaseDocumentTile title={title} fileName={fullName} onClick={fire} />
      )}
    />
  );
};

export default TemplateDocumentItem;
